// components/controlMapping.ts

export interface ControlMapping {
  moveLeft: string;
  moveRight: string;
  moveUp: string;
  moveDown: string;
  jump: string;
  attack: string;
  special: string;
}

export interface PresetMapping {
  player1: ControlMapping;
  player2: ControlMapping;
  isModern?: boolean; // Flag for mouse-based controls
}

// Your default controls
export const defaultControlMapping: PresetMapping = {
  player1: {
    moveLeft: 'a',
    moveRight: 'd',
    moveUp: 'w',
    moveDown: 's',
    jump: 'ShiftLeft',
    attack: 'f',
    special: 'g'
  },
  player2: {
    moveLeft: 'ArrowLeft',
    moveRight: 'ArrowRight',
    moveUp: 'ArrowUp',
    moveDown: 'ArrowDown',
    jump: 'ShiftRight',
    attack: '/',
    special: '.'
  }
};

// Additional presets (example for web and mobile)
export const presetControlMappings: { [key: string]: PresetMapping } = {
  default: defaultControlMapping,
  modern: {
    player1: {
      moveLeft: 'a',
      moveRight: 'd',
      moveUp: 'w',
      moveDown: 's',
      jump: 'ShiftLeft', // Used for blocking
      attack: 'leftclick', // left mouse button
      special: 'rightclick' // right mouse button
    },
    player2: {
      moveLeft: 'ArrowLeft',
      moveRight: 'ArrowRight',
      moveUp: 'ArrowUp',
      moveDown: 'ArrowDown',
      jump: 'ShiftRight',
      attack: '/',
      special: '.'
    },
    isModern: true // Flag this as a modern control scheme
  },
  web: {
    player1: {
      moveLeft: 'a',
      moveRight: 'd',
      moveUp: 'w',
      moveDown: 's',
      jump: ' ',  // Use a space character here
      attack: 'j',
      special: 'k'
    },
    player2: {
      moveLeft: 'ArrowLeft',
      moveRight: 'ArrowRight',
      moveUp: 'ArrowUp',
      moveDown: 'ArrowDown',
      jump: ' ',  // Use a space character here
      attack: 'n',
      special: 'm'
    }
  },
  mobile: {
    // Mobile presets might map actions to on-screen buttons instead
    // Here we simply use alternative keys as placeholders
    player1: {
      moveLeft: 'a',
      moveRight: 'd',
      moveUp: 'w',
      moveDown: 's',
      jump: 'q',
      attack: 'e',
      special: 'r'
    },
    player2: {
      moveLeft: 'ArrowLeft',
      moveRight: 'ArrowRight',
      moveUp: 'ArrowUp',
      moveDown: 'ArrowDown',
      jump: 'ShiftRight',
      attack: 'o',
      special: 'p'
    }
  }
};

// Function to load saved control preset from localStorage
// Changed default return value to 'modern'
export const loadSavedControlPreset = (): string => {
  try {
    const savedPreset = localStorage.getItem('controlPreset');
    if (savedPreset && presetControlMappings[savedPreset]) {
      return savedPreset;
    }
  } catch (error) {
    console.error("Error loading saved control preset:", error);
  }
  return 'modern'; // Changed default to modern if nothing saved or error
};

// Function to save control preset to localStorage
export const saveControlPreset = (presetName: string): void => {
  try {
    if (presetControlMappings[presetName]) {
      localStorage.setItem('controlPreset', presetName);
    }
  } catch (error) {
    console.error("Error saving control preset:", error);
  }
};